import type { CompanyDirectoryUser } from '../types';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import HttpUtils from '~/agent/http-utils';

const { APP_CONSTANTS } = window;

export interface GetCompanyLeaderboardParams {
  items: number;
  startDate: number;
  endDate: number;
  contentType: string;
}

const BADGES_LEADERBOARD_QUERY_KEY = APP_CONSTANTS.LEADERBOARD_TYPES.BADGES;
const COMPLETION_LEADERBOARD_QUERY_KEY = APP_CONSTANTS.LEADERBOARD_TYPES.COMPLETION;

export function getCompanyLeaderboard(
  params: GetCompanyLeaderboardParams,
  leaderboardType: string,
): Promise<CompanyDirectoryUser[]> {
  return FetchPromise.get(HttpUtils.buildUriWithQueryString(`company/leaderboards/${leaderboardType}`, params));
}

export function useGetCompanyBadgesLeaderboardQuery(
  params: GetCompanyLeaderboardParams,
  queryOptions: UseQueryOptions<CompanyDirectoryUser[], JQuery.jqXHR> = {},
) {
  return useQuery<CompanyDirectoryUser[], JQuery.jqXHR>(
    [BADGES_LEADERBOARD_QUERY_KEY, params],
    () => getCompanyLeaderboard(params, APP_CONSTANTS.LEADERBOARD_TYPES.BADGES),
    queryOptions,
  );
}

export function useGetCompanyCompletionLeaderboardQuery(
  params: GetCompanyLeaderboardParams,
  queryOptions: UseQueryOptions<CompanyDirectoryUser[], JQuery.jqXHR> = {},
) {
  return useQuery<CompanyDirectoryUser[], JQuery.jqXHR>(
    [COMPLETION_LEADERBOARD_QUERY_KEY, params],
    () => getCompanyLeaderboard(params, APP_CONSTANTS.LEADERBOARD_TYPES.COMPLETION),
    queryOptions,
  );
}
